const ArgumentType = require('../../extension-support/argument-type');
const BlockType = require('../../extension-support/block-type');
const formatMessage = require('format-message');
const SensorPeripheral = require('../common/sensor-peripheral');
const { default: bleUtils } = require('../../util/ble');
const { BLE_CONFIG } = require('../../util/bleCharac');


/**
 * 6轴加速度计
 * 
 * @readonly
 */
const DIVECE_OPT = {
    type: 'sensor'
};

// const BLE_CONFIG = {
//     prefix: 'LM',
//     SERVICE_UUID: 0x03FF,
//     // ROLL_UUID: 0x0400,
//     // PITCH_UUID: 0x0401,
//     // YAW_UUID: 0x0402,
//     acceleration: 0x0403,
//     gyroscope: 0x0404,
// }
/**
 * Manage communication with a Arduino esp32 peripheral over a Scratch Link client socket.
 */
class YMIMU6 extends SensorPeripheral {
    /**
     * Construct a Arduino communication object.
     * @param {Runtime} runtime - the Scratch runtime
     * @param {string} deviceId - the id of the extension
     * @param {string} originalDeviceId - the original id of the peripheral, like xxx_arduinoUno
     */
    constructor(runtime, deviceId, originalDeviceId) {
        super(runtime, deviceId, originalDeviceId, null, BLE_CONFIG, DIVECE_OPT);
    }
}

class ScratchYMIMU6Device {

    /**
     * @return {string} - the ID of this deivce.
     */
    get DEVICE_ID() {
        return 'yiImu06';
    }

    /**
     * Construct a set of Arduino blocks.
     * @param {Runtime} runtime - the Scratch runtime.
     * @param {string} originalDeviceId - the original id of the peripheral, like xxx_arduinoUno
     */
    constructor(runtime, originalDeviceId) {
        /**
         * The Scratch runtime.
         * @type {Runtime}
         */
        this.runtime = runtime;

        
        this._peripheral = new YMIMU6(this.runtime, this.DEVICE_ID, originalDeviceId);
        this.bleUtils = new bleUtils();
    }

    getInfo() {
        return [{
            id: 'yiImu06',
            name: formatMessage({
                id: 'YMIMU6.categoryName',
                default: 'YM IMU6',
                description: 'Label for the YM IMU6 extension category'
            }),
            color1: "#536DFE",
            color2: "#4A64F7",
            color3: "#405BF0",
            blocks: [
                {
                    opcode: 'connect',
                    blockType: BlockType.COMMAND,
                    text: formatMessage({
                        id: 'YMIMU6.ble.connect',
                        default: 'connect to YM-IMU6-[DEVICE_NAME]',
                        description: 'Connect to YM IMU6'
                    }),
                    arguments: {
                        DEVICE_NAME: {
                            type: ArgumentType.STRING,
                            defaultValue: ' ',
                        }
                    }
                },
                {
                    opcode: 'disConnect',
                    blockType: BlockType.COMMAND,
                    text: formatMessage({
                        id: 'YMIMU6.ble.disconnect',
                        default: 'disconnect from YM IMU6',
                        description: 'Disconnect from YM IMU6'
                    })
                },
                // {
                //     opcode: 'getRollAngle',
                //     blockType: BlockType.REPORTER,
                //     text: formatMessage({
                //         id: 'YMIMU6.getRollAngle',
                //         default: 'get rollAngle',
                //         description: 'Get the getRollAngle of the sensor'
                //     })
                // },
                // {
                //     opcode: 'getPitchAngle',
                //     blockType: BlockType.REPORTER,
                //     text: formatMessage({
                //         id: 'YMIMU6.getPitchAngle',
                //         default: 'get pitchAngle',
                //         description: 'Get the current pitchAngle'
                //     })
                // },
                // {
                //     opcode: 'getYawAngle',
                //     blockType: BlockType.REPORTER,
                //     text: formatMessage({
                //         id: 'YMIMU6.getYawAngle',
                //         default: 'get yawAngle',
                //         description: 'Get the current yawAngle'
                //     })
                // },
                {
                    opcode: 'getAccelerationX',
                    blockType: BlockType.REPORTER,
                    text: formatMessage({
                        id: 'YMIMU6.getAccelerationX',
                        default: 'get x of acceleration',
                        description: 'Get the acceleration of the sensor'
                    })
                },
                {
                    opcode: 'getAccelerationY',
                    blockType: BlockType.REPORTER,
                    text: formatMessage({
                        id: 'YMIMU6.getAccelerationY',
                        default: 'get y of acceleration',
                        description: 'Get the acceleration of the sensor'
                    })
                },
                {
                    opcode: 'getAccelerationZ',
                    blockType: BlockType.REPORTER,
                    text: formatMessage({
                        id: 'YMIMU6.getAccelerationZ',
                        default: 'get z of acceleration',
                        description: 'Get the acceleration of the sensor'
                    })
                },
                {
                    opcode: 'getGyroscopeX',
                    blockType: BlockType.REPORTER,
                    text: formatMessage({
                        id: 'YMIMU6.getGyroscopeX',
                        default: 'get x of gyroscope',
                        description: 'Get the gyroscope of the sensor'
                    })
                },
                {
                    opcode: 'getGyroscopeY',
                    blockType: BlockType.REPORTER,
                    text: formatMessage({
                        id: 'YMIMU6.getGyroscopeY',
                        default: 'get y of gyroscope',
                        description: 'Get the gyroscope of the sensor'
                    })
                },
                {
                    opcode: 'getGyroscopeZ',
                    blockType: BlockType.REPORTER,
                    text: formatMessage({
                        id: 'YMIMU6.getGyroscopeZ',
                        default: 'get z of gyroscope',
                        description: 'Get the gyroscope of the sensor'
                    })
                },
            ],
            menus: {}
        }];
    }

    async connect(args) {
        const deviceName = 'YM-IMU6-' + (args.DEVICE_NAME?.trim() || "");
        const connected = await this.isConnected();
        if (connected) {
            console.log('Already connected to device');
            return;
        }
        console.log(`Connecting to YM IMU6 device: ${deviceName}`);
        try {
            await this.bleUtils.connect(deviceName, BLE_CONFIG.SERVICE_UUID);
            console.log(`Connected to device: ${deviceName}`);

        } catch (error) {
            console.error(`Failed to connect to ${deviceName}:`, error);
        }
    }

    async isConnected() {
        console.log('Checking if device is connected');
        return this.bleUtils.device !== null && this.bleUtils.device.gatt.connected;
    }

    async disConnect() {
        console.log('Disconnecting from YM IMU6 device');
        if (this.bleUtils.device) {
            try {
                await this.bleUtils.disConnect(this.bleUtils.device);
                console.log('Disconnected from device');
            } catch (error) {
                console.error('Failed to disconnect:', error);
            }
        }
    }

    // async getRollAngle() {
    //     if (this.bleUtils.device) {
    //         try {
    //             const characteristic = await this.bleUtils.getCharacteristic(this.bleUtils.service, BLE_CONFIG.ROLL_UUID);
    //             const dataView = await this.bleUtils.readCharacteristic(characteristic);
    //             if (dataView?.buffer instanceof ArrayBuffer) {
    //                 //解析数据
    //                 let buffer = Array.from(new Uint8Array(dataView.buffer));
    //                 const hexStr = buffer.map(_ => {
    //                     return this.bleUtils.int2Hex(_);
    //                 }).reverse().join("");
    //                 const roll = this.bleUtils.hex2float(hexStr, 2, 4);
    //                 console.log(`roll: ${roll}`);
    //                 if (isNaN(roll)) {
    //                     console.error('roll is NaN');
    //                     return 0;
    //                 }
    //                 return roll;
    //             }
    //         } catch (error) {
    //             console.error('Failed to get roll:', error);
    //             return 0;
    //         }
    //     }
    // }

    // async getPitchAngle() {
    //     if (this.bleUtils.device) {
    //         try {
    //             const characteristic = await this.bleUtils.getCharacteristic(this.bleUtils.service, BLE_CONFIG.PITCH_UUID);
    //             const dataView = await this.bleUtils.readCharacteristic(characteristic);
    //             if (dataView?.buffer instanceof ArrayBuffer) {
    //                 //解析数据
    //                 let buffer = Array.from(new Uint8Array(dataView.buffer));
    //                 const hexStr = buffer.map(_ => {
    //                     return this.bleUtils.int2Hex(_);
    //                 }).reverse().join("");
    //                 const patch = this.bleUtils.hex2float(hexStr, 2, 4);
    //                 console.log(`patch: ${patch}`);
    //                 if (isNaN(patch)) {
    //                     console.error('patch is NaN');
    //                     return 0;
    //                 }
    //                 return patch;
    //             }
    //         } catch (error) {
    //             console.error('Failed to get patch:', error);
    //             return 0;
    //         }
    //     }
    // }

    // async getYawAngle() {
    //     if (this.bleUtils.device) {
    //         try {
    //             const characteristic = await this.bleUtils.getCharacteristic(this.bleUtils.service, BLE_CONFIG.YAW_UUID);
    //             const dataView = await this.bleUtils.readCharacteristic(characteristic);
    //             if (dataView?.buffer instanceof ArrayBuffer) {
    //                 //解析数据
    //                 let buffer = Array.from(new Uint8Array(dataView.buffer));
    //                 const hexStr = buffer.map(_ => {
    //                     return this.bleUtils.int2Hex(_);
    //                 }).reverse().join("");
    //                 const yaw = this.bleUtils.hex2float(hexStr, 2, 4);
    //                 console.log(`yaw: ${yaw}`);
    //                 if (isNaN(yaw)) {
    //                     console.error('yaw is NaN');
    //                     return 0;
    //                 }
    //                 return yaw;
    //             }
    //         } catch (error) {
    //             console.error('Failed to get yaw:', error);
    //             return 0;
    //         }
    //     }
    // }

    async getAccelerationX() {
        if (this.bleUtils.device) {
            try {
                const characteristic = await this.bleUtils.getCharacteristic(this.bleUtils.service, BLE_CONFIG.acceleration);
                const dataView = await this.bleUtils.readCharacteristic(characteristic);
                if (dataView?.buffer instanceof ArrayBuffer) {
                    //解析数据
                    let buffer = Array.from(new Uint8Array(dataView.buffer));
                    let xBuffer = buffer.slice(0, 4);
                    const xHexStr = xBuffer.map(_ => {
                        return this.bleUtils.int2Hex(_);
                    }).reverse().join("");
                    const x = this.bleUtils.hex2float(xHexStr, 2, 4) || 0;
                    console.log('AccelerationX', x);
                    return x;
                }
            } catch (error) {
                console.error('Failed to get roll:', error);
                return 0;
            }
        }
    }
    async getAccelerationY() {
        if (this.bleUtils.device) {
            try {
                const characteristic = await this.bleUtils.getCharacteristic(this.bleUtils.service, BLE_CONFIG.acceleration);
                const dataView = await this.bleUtils.readCharacteristic(characteristic);
                if (dataView?.buffer instanceof ArrayBuffer) {
                    //解析数据
                    let buffer = Array.from(new Uint8Array(dataView.buffer));
                    let yBuffer = buffer.slice(4, 8);
                    const yHexStr = yBuffer.map(_ => {
                        return this.bleUtils.int2Hex(_);
                    }).reverse().join("");
                    const y = this.bleUtils.hex2float(yHexStr, 2, 4) || 0;
                    console.log('AccelerationY', y);
                    return y;
                }
            } catch (error) {
                console.error('Failed to get roll:', error);
                return 0;
            }
        }
    }
    async getAccelerationZ() {
        if (this.bleUtils.device) {
            try {
                const characteristic = await this.bleUtils.getCharacteristic(this.bleUtils.service, BLE_CONFIG.acceleration);
                const dataView = await this.bleUtils.readCharacteristic(characteristic);
                if (dataView?.buffer instanceof ArrayBuffer) {
                    //解析数据
                    let buffer = Array.from(new Uint8Array(dataView.buffer));
                    let zBuffer = buffer.slice(8, 12);
                    const zHexStr = zBuffer.map(_ => {
                        return this.bleUtils.int2Hex(_);
                    }).reverse().join("");
                    const z = this.bleUtils.hex2float(zHexStr, 2, 4) || 0;
                    console.log('AccelerationZ', z);
                    return z;
                }
            } catch (error) {
                console.error('Failed to get roll:', error);
                return 0;
            }
        }
    }

    async getGyroscopeX() {
        if (this.bleUtils.device) {
            try {
                const characteristic = await this.bleUtils.getCharacteristic(this.bleUtils.service, BLE_CONFIG.gyroscope);
                const dataView = await this.bleUtils.readCharacteristic(characteristic);
                if (dataView?.buffer instanceof ArrayBuffer) {
                    //解析数据
                    let buffer = Array.from(new Uint8Array(dataView.buffer));
                    let xBuffer = buffer.slice(0, 4);
                    const xHexStr = xBuffer.map(_ => {
                        return this.bleUtils.int2Hex(_);
                    }).reverse().join("");

                    const x = this.bleUtils.hex2float(xHexStr, 2, 4) || 0;
                    console.log(`x: ${x}`);
                    return x;
                }
            } catch (error) {
                console.error('Failed to get roll:', error);
                return 0;
            }
        }
    }
    async getGyroscopeY() {
        if (this.bleUtils.device) {
            try {
                const characteristic = await this.bleUtils.getCharacteristic(this.bleUtils.service, BLE_CONFIG.gyroscope);
                const dataView = await this.bleUtils.readCharacteristic(characteristic);
                if (dataView?.buffer instanceof ArrayBuffer) {
                    //解析数据
                    let buffer = Array.from(new Uint8Array(dataView.buffer));
                    let yBuffer = buffer.slice(4, 8);
                    const yHexStr = yBuffer.map(_ => {
                        return this.bleUtils.int2Hex(_);
                    }).reverse().join("");
                    const y = this.bleUtils.hex2float(yHexStr, 2, 4) || 0;
                    console.log(`y: ${y}`);
                    return y;
                }
            } catch (error) {
                console.error('Failed to get roll:', error);
                return 0;
            }
        }
    }
    async getGyroscopeZ() {
        if (this.bleUtils.device) {
            try {
                const characteristic = await this.bleUtils.getCharacteristic(this.bleUtils.service, BLE_CONFIG.gyroscope);
                const dataView = await this.bleUtils.readCharacteristic(characteristic);
                if (dataView?.buffer instanceof ArrayBuffer) {
                    //解析数据
                    let buffer = Array.from(new Uint8Array(dataView.buffer));
                    let zBuffer = buffer.slice(8, 12);
                    const zHexStr = zBuffer.map(_ => {
                        return this.bleUtils.int2Hex(_);
                    }).reverse().join("");
                    const z = this.bleUtils.hex2float(zHexStr, 2, 4) || 0;
                    console.log(`z: ${z}`);
                    return z;
                }
            } catch (error) {
                console.error('Failed to get roll:', error);
                return 0;
            }
        }
    }

}

module.exports = ScratchYMIMU6Device;